import { serverForImages } from "../../config";

interface IAudioItem {
  title: string;
  innerDescription: string;
  url: string;
}
const AudioItem: React.FC<IAudioItem> = ({ title, innerDescription, url }) => {
  return (
    <div className="my-12">
      <p className="font-semibold mb-[8px]">{title}</p>
      <p className="mb-[24px]">{innerDescription}</p>
      <audio controls className="w-full">
        <source src={`${serverForImages}${url}`} type="audio/mp3" />
        A böngésző nem támogatja a hanglejátszást.
      </audio>
    </div>
  )
}

export default AudioItem;
